import { createReducer, on } from '@ngrx/store';
import { isObject, toLower } from 'lodash-es';

import { ApiRequestType } from 'src/app/shared/enums/api.enums';
import { validArray } from 'src/app/shared/utilities/types.utils';
import { apiResponse, postApiRequest } from '../api/api.actions';
import { isApi } from '../api/api.utilities';
import { LocaleEntry } from '../api/responses/get-application-locale';
import { clearLocales, fetchLocaleFile, fetchLocaleFileSuccess } from './locale.actions';
import { initialState } from './locale.state';

const { isArray } = Array;

const { GET_APPLICATION_LOCALE } = ApiRequestType;

export const localeReducer = createReducer(
	initialState,
	on(clearLocales, (state) => ({ ...state, locales: {} })),
	on(fetchLocaleFile, (state) => ({ ...state, loadingFiles: true })),
	on(fetchLocaleFileSuccess, (state) => ({ ...state, loadingFiles: false })),
	on(postApiRequest, (state, action) => {
		if (!isApi(action, GET_APPLICATION_LOCALE)) {
			return state;
		}

		return {
			...state,
			loading: true,
		};
	}),
	on(apiResponse, (state, action) => {
		if (!isApi(action, GET_APPLICATION_LOCALE)) {
			return state;
		}

		const response = action.response;
		const requestedSections = action.params.section_list.split(',');
		const newState = {
			...state,
			loading: false,
			locales: { ...state.locales },
		};

		requestedSections.forEach((section: string) => {
			const sectionLowerCased = toLower(section);
			if (!isObject(newState.locales[sectionLowerCased])) {
				newState.locales[sectionLowerCased] = {};
			}
		});

		const { LANGUAGE } = response;
		if (action.isOk && isArray(LANGUAGE)) {
			LANGUAGE.forEach((data) => {
				Object.keys(data).forEach((section: string) => {
					const sectionLowerCased = toLower(section);

					if (section === 'language' || !isArray(data[section])) {
						return;
					}

					data[section].forEach(({ LT }) => {
						if (validArray(LT)) {
							LT.forEach((localeTarget: LocaleEntry) => {
								const { target, value } = localeTarget;
								newState.locales[sectionLowerCased] = {
									...newState.locales[sectionLowerCased],
									[toLower(target)]: value,
								};
							});
						}
					});
				});
			});
		}
		return newState;
	})
);
